import React, { useCallback, useEffect } from "react";
import "./otpVerificationPopup.css";
import confirmationImage from "../../assets/otpConfirmation.svg";

const OtpVerificationPopup = ({ onClose, sendOtp, phone_number }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    sendOtp(e);
    onClose();
  };

  const maskPhoneNumber = (phoneNumber) =>
    phoneNumber
      ? `+1 ${phoneNumber
          .replace(/.(?=.{4})/g, "X")
          .replace(/(\w{3})(\w{3})(\w{4})/, "$1 $2 $3")}`
      : "Invalid phone number";

  return (
    <div className="otp-verification-popup">
      <div className="popup-content">
        <img
          src={confirmationImage}
          alt="Verify your number"
          className="popup-image"
        />
        <h1 className="popup-title">Verify your number</h1>
        <blockquote className="popup-description">
          We will send you an OTP to your Phone number
        </blockquote>
        <div className="popup-phone-number">
          {maskPhoneNumber(phone_number)}
        </div>
        <button className="request-otp-btn" onClick={handleSubmit}>
          Request OTP
        </button>
      </div>
    </div>
  );
};

export default OtpVerificationPopup;
